<template>
	<div class="trailerCharts-item">
		<div class="trailerCharts-item__graph">
			<div
					v-for="(item, index) in itemData"
					:key="index"
					class="trailerCharts-item__graph-item"
					:style="{
            height: `${65 - (diagramValues[keyName] - item.amount) / 0.01}%`,
          }"
			>
				<span class="text-month">{{ item.month }}</span>
				<span class="text-price">${{ item.amount }}</span>
			</div>
		</div>
		<svg-sprite width="267" height="58" :icon-id="`truck_${keyName}`"></svg-sprite>
	</div>
</template>

<script>
export default {
	name: "TrailerChartsItem",
	props: {
		itemData: Object,
		keyName: String,
		diagramValues: Object
	}
};
</script>

<style scoped lang="scss">
.trailerCharts-item {
  margin-bottom: 20px;
  &__graph {
    width: 70%;
    height: 76px;
    display: flex;
    align-items: flex-end;
    margin-left: auto;
    justify-content: space-between;
    padding: 2px 4px;

    &-item {
      width: calc(25% - 3px);
      background: rgba(143, 144, 166, 0.2);
      border-radius: 4px 4px 0 0;
      position: relative;
      text-align: center;

      &:last-child {
        background: rgba(25, 188, 56, 0.5);
      }

      .text-month {
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px; /* 133.333% */
        letter-spacing: 1px;
        text-transform: uppercase;
      }
	    
      .text-price {
        position: absolute;
        left: 50%;
        transform: translate(-50%, -20px);
        color: var(--card-color);
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px; /* 133.333% */
        letter-spacing: 0.25px;
      }
    }
  }
}
</style>
